import styled from "styled-components";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
  height: 100vh;
  width: 100%;
`;

export const TabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1450px;
  padding-inline: 25px;
`;

export const FilterRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const FilterItem = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1450px;
  padding-inline: 25px;
`; 